//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  selectDindustryListByTitle,
  getAllDictionary //查询行业三级联动
} from "@/assets/js/api";
export default {
  name: "common-area",
  props: ["industryId",'areaArr'],
  data() {
    return {
      nowLevel: 0, //当前正在选择的行业级别
      chooseAreaArr: [
        //当前选择的行业数组
        {
          id: null,
          name: "请选择"
        }
      ],
      allArea: null, //所有行业
      // areaArr: {}, //行业数组
      nowIndex: null, //当前选择的下标
      areaArrList: [{}, {}, {}], //不同级别的行业数组
      indexList: [null, null, null] //不同级别选择的行业下标
    };
  },
  created() {
  },
  mounted() {
    // this.getData();
  },
  methods: {
    //初始化
    init() {
      this.nowLevel = 0; //当前正在选择的行业级别
      this.chooseAreaArr = [
        //当前选择的行业数组
        {
          id: null,
          name: "请选择"
        }
      ];
      this.areaArr = {}; //行业数组
      this.nowIndex = null; //当前选择的下标
      this.areaArrList = [{}, {}, {}]; //不同级别的行业数组
      this.indexList = [null, null, null]; //不同级别选择的行业下标
      // this.getData();
    },
    //获取行业三级联动信息
    // getData() {
    //   if (this.fTitle) {
    //     selectDindustryListByTitle({data:{
    //       ftitleId:this.fTitle
    //     }})
    //       .then(res => {
    //         this.allArea = res.data;
    //         this.areaArr = res.data;
    //         this.areaArrList[0] = res.data;
    //         if (
    //           this.areaId !== undefined &&
    //           this.areaId !== null &&
    //           this.areaId !== ""
    //         ) {
    //           this.chooseAreaFn();
    //         }
    //       })
    //       .catch(res => {
    //         return;
    //       });
    //   }
    // },
    //自动选择行业
    chooseAreaFn() {
      let isTrue = false;
      let fn = (data, lev) => {
        for (let i = 0; i < data.length; i++) {
          if (isTrue) {
            return;
          }
          this.indexList[lev] = i;
          this.chooseAreaArr[lev] = {
            id: data[i].id,
            name: data[i].industryName
          };
          this.areaArr = data;
          this.areaArrList[lev] = data;
          if (data[i].list && data[i].list.length > 0) {
            fn(data[i].list, 1);
          } else if (data[i].list && data[i].list.length > 0) {
            fn(data[i].list, 2);
          } else {
            if (this.areaId == data[i].id) {
              this.nowIndex = i;
              this.nowLevel = lev;
              isTrue = true;
              return;
            }
          }
        }
      };
      fn(this.allArea, 0);
      if (!isTrue) {
        this.nowLevel = 0; //当前正在选择的行业级别
        this.chooseAreaArr = [
          //当前选择的行业数组
          {
            id: null,
            name: "请选择"
          }
        ];
        this.areaArr = this.allArea; //行业数组
        this.nowIndex = null; //当前选择的下标
        this.areaArrList = [{}, {}, {}]; //不同级别的行业数组
        this.indexList = [null, null, null]; //不同级别选择的行业下标
      }
    },
    //选择行业
    chooseFn(item) {
      this.$emit("areaBack", item);
    },
    //返回到某一级的行业选择
    backFn(i) {
      this.nowLevel = i;
      this.nowIndex = this.indexList[i];
      this.areaArr = this.areaArrList[i];
    },
    //关闭回调
    closeFn() {
      this.$emit("close");
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/common-industry2.vue